/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataUserPointsHistoryRespVo } from './PageDataUserPointsHistoryRespVo';
import {
    PageDataUserPointsHistoryRespVoFromJSON,
    PageDataUserPointsHistoryRespVoFromJSONTyped,
    PageDataUserPointsHistoryRespVoToJSON,
    PageDataUserPointsHistoryRespVoToJSONTyped,
} from './PageDataUserPointsHistoryRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataUserPointsHistoryRespVo
 */
export interface ResponsePageDataUserPointsHistoryRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataUserPointsHistoryRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataUserPointsHistoryRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataUserPointsHistoryRespVo}
     * @memberof ResponsePageDataUserPointsHistoryRespVo
     */
    data?: PageDataUserPointsHistoryRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataUserPointsHistoryRespVo interface.
 */
export function instanceOfResponsePageDataUserPointsHistoryRespVo(value: object): value is ResponsePageDataUserPointsHistoryRespVo {
    return true;
}

export function ResponsePageDataUserPointsHistoryRespVoFromJSON(json: any): ResponsePageDataUserPointsHistoryRespVo {
    return ResponsePageDataUserPointsHistoryRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataUserPointsHistoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataUserPointsHistoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataUserPointsHistoryRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataUserPointsHistoryRespVoToJSON(json: any): ResponsePageDataUserPointsHistoryRespVo {
    return ResponsePageDataUserPointsHistoryRespVoToJSONTyped(json, false);
}

export function ResponsePageDataUserPointsHistoryRespVoToJSONTyped(value?: ResponsePageDataUserPointsHistoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataUserPointsHistoryRespVoToJSON(value['data']),
    };
}

